import { dayCategoryTotals } from '@wiztime/core';
import { useTranslation } from 'react-i18next';
import { useProjects } from '../hooks/useProjects';
import { useVisibleBlocks } from '../hooks/useVisibleBlocks';
import { CATEGORY_COLOR } from '../lib/categoryColor';
import { formatHours } from '../lib/format';
import styles from './TopBar.module.css';

/** "Work 6h · Rest 2h · Life 0h · N to confirm": confirmed time of the viewed day. */
export function DayStats({ date }: { date: string }) {
  const { t } = useTranslation();
  const { blocks } = useVisibleBlocks(date);
  const projects = useProjects();
  const totals = dayCategoryTotals(blocks, projects.all);
  return (
    <p className={styles.dayStats} aria-label={t('dayStats.label')} data-testid="day-stats">
      <span>
        <span className={styles.statDot} style={{ background: CATEGORY_COLOR.work }} aria-hidden="true" />
        {t('category.work')} {formatHours(totals.byCategory.work)}
      </span>
      <span>
        <span className={styles.statDot} style={{ background: CATEGORY_COLOR.rest }} aria-hidden="true" />
        {t('category.rest')} {formatHours(totals.byCategory.rest)}
      </span>
      <span>
        <span className={styles.statDot} style={{ background: CATEGORY_COLOR.life }} aria-hidden="true" />
        {t('category.life')} {formatHours(totals.byCategory.life)}
      </span>
      <span className={totals.draftCount > 0 ? styles.pending : undefined}>
        {t('dayStats.pending', { count: totals.draftCount })}
      </span>
    </p>
  );
}
